import React from "react";
import PropTypes from "prop-types";
import ReactSVG from "react-svg";
import ReactMarkdown from "react-markdown";
import cx from "classnames";
import { withTranslation } from "react-i18next";

@withTranslation()
class ChangeItem extends React.Component {
    constructor() {
        super();
        this.state = {
            multiLine: false,
            open: false,
        };
        this.isLink = this.constructor.isLink;
        this.contentRef = React.createRef();
        this.LINE_HEIGHT = 21;
        this.MAX_LINES_COUNT = 3;
    }

    componentDidMount() {
        const textHeight = this.contentRef.current.offsetHeight;
        if (textHeight / this.LINE_HEIGHT > this.MAX_LINES_COUNT) {
            this.setState({ multiLine: true });
        }
    }

    toggleContent = () => this.setState(prevState => ({ open: !prevState.open }));

    getPrefix = () => {
        const { data, t } = this.props;
        return data.oldValue ? `${t("appealHistory.updated")} - ` : "";
    };

    parseLinksAndText = text => {
        const parts = [];
        const regex = /\[(.*?)\]\((.*?)\)/g;
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                parts.push({ type: "text", content: text.slice(lastIndex, match.index) });
            }
            parts.push({ type: "link", content: match[1], href: match[2] });
            lastIndex = regex.lastIndex;
        }

        if (lastIndex < text.length) {
            parts.push({ type: "text", content: text.slice(lastIndex) });
        }

        return parts;
    };

    renderParsedContent = value => {
        const parsedContent = this.parseLinksAndText(value);
        return parsedContent.map((part, index) => {
            if (part.type === "link") {
                return (
                    <a key={index} href={part.href} className="custom-link">
                        <ReactSVG src={`/data/svg/history/link.svg`} />
                        <span>{part.content}</span>
                    </a>
                );
            }
            return (
                <span key={index} className="history-content-text-mid">
                    {part.content}
                </span>
            );
        });
    };

    getMarkdownProps = value => {
        return {
            source: value,
            unwrapDisallowed: true, // still place content of disallowedTypes
            disallowedTypes: ["paragraph"], // remove all paragraphs <p></p>render
        };
    };

    isMarkdownLinkPattern = value => {
        const markdownLinkPattern = /^\[(.*?)\]\((.*?)\)\s.*\s\[(.*?)\]\((.*?)\)$/;
        // const markdownLinkPattern = /^(\[(.*?)\]\((.*?)\)(\s.*\s\[(.*?)\]\((.*?)\))?)$/;
        return markdownLinkPattern.test(value);
    };

    renderLink = ({ href, children }) => {
        return (
            <a href={href} className="custom-link">
                <ReactSVG src={`/data/svg/history/link.svg`} />
                <span>{children}</span>
            </a>
        );
    };

    getMarkdownProps = value => {
        return {
            source: value,
            unwrapDisallowed: true, // still place content of disallowedTypes
            disallowedTypes: ["paragraph"], // remove all paragraphs <p></p>render
            renderers: {
                link: this.renderLink, // Use custom render for links
            },
        };
    };

    escapeBareSquareBrackets = (value = "") => value.replace(/\[([^\]\n]+)\](?!\s*\()/g, "\\[$1\\]");

    render() {
        const { data, highlight } = this.props;
        const { multiLine, open } = this.state;

        const safeNewValue = data?.newValue ? this.escapeBareSquareBrackets(data.newValue) : "";
        const safeOldValue = data?.oldValue ? this.escapeBareSquareBrackets(data.oldValue) : "";

        return (
            <div className={cx("history-item", { multiLine })}>
                <div
                    className={cx("history-item-content history-item-change", { limited: multiLine && !open })}
                    ref={this.contentRef}
                >
                    <div className="history-content-attribute">{highlight(data.attributeName)}: </div>

                    <div className="history-content-text-wrapper">
                        {safeNewValue && (
                            <span className="history-content-text">
                                {this.isMarkdownLinkPattern(safeNewValue)
                                    ? highlight(this.renderParsedContent(safeNewValue))
                                    : highlight(<ReactMarkdown {...this.getMarkdownProps(safeNewValue)} />)}
                            </span>
                        )}

                        {safeOldValue && (
                            <span className="history-content-text old-changes">
                                {this.isMarkdownLinkPattern(safeOldValue)
                                    ? highlight(this.renderParsedContent(safeOldValue))
                                    : highlight(<ReactMarkdown {...this.getMarkdownProps(safeOldValue)} />)}
                            </span>
                        )}
                    </div>
                </div>

                {multiLine && (
                    <div className={cx("button-hover-half-circle", { active: open })} onClick={this.toggleContent}>
                        <ReactSVG className="button-icon button-icon-toggle" src={`/data/svg/history/kebab.svg`} />
                    </div>
                )}
            </div>
        );
    }
}

ChangeItem.propTypes = {
    data: PropTypes.object,
    highlight: PropTypes.func,
};

export default ChangeItem;
